import "./GroupedAppHeader.scss";
import type { FC } from "react";
import { capitalize } from "lodash-es";
import {
  AppMainHeader,
  AppHeaderLogoAndMainNav,
  AppHeaderSecondaryNav,
} from "@SeemplicityDev/shared";
import { useAppStyling } from "../../WhiteLabel/useAppStyling";
import GroupedNav from "./GroupedNav";
import GroupedHeaderRail from "./GroupedHeaderRail";
import { useGroupedNavConfig } from "./groupedNavConfig";

const GroupedAppHeader: FC = () => {
  const { appProps } = useAppStyling();
  const { groups, appsMenu, seema } = useGroupedNavConfig();

  return (
    <AppMainHeader
      className="seem-app-header grouped-app-header"
      dataTestId="grouped-app-header"
    >
      <AppHeaderLogoAndMainNav
        logos={[
          {
            src: appProps?.logo?.app,
            label: capitalize(appProps?.orgName),
          },
        ]}
      >
        <GroupedNav groups={groups} />
      </AppHeaderLogoAndMainNav>
      <AppHeaderSecondaryNav>
        <GroupedHeaderRail appsMenu={appsMenu} seema={seema} />
      </AppHeaderSecondaryNav>
    </AppMainHeader>
  );
};

export default GroupedAppHeader;
